
@if (document && documentFields.length > 0) {
  <div class="grid grid-nogutter">
    @for (documentField of documentFields; track documentField.name; let index = $index) {
      <div class="col-12 md:col-5 metadata-cell">
        <div class="field-label"><span>{{utilitiesService.getLocalisedValue(documentField)}}</span></div>
        @if (documentField.tooltip_en && documentField.tooltip_fr) {
          <i [pTooltip]="locale === 'fr' ? documentField.tooltip_fr : documentField.tooltip_en" class="fa fa-solid fa-circle-info metadata-info"></i>
        }
      </div>
      <div class="col-12 md:col-7 metadata-cell">
        <!-- start field switcher -->
        @switch (documentField.type) {
          @case ('text') {
            <div style="display: block">
              <input pInputText type="text" [ngModel]="getDoc(documentField.name)" (ngModelChange)="setDoc(documentField.name, $event)" [name]="documentField.name"
                [required]="respectRequired && documentField.required === true" [readonly]="mode !== DetailMode.EDITION" class="acted-highlight-req metadata-field"
                [ngClass]="(mode === 'edition' && documentField.recommended && !getDoc(documentField.name)) ? 'acted-highlight-recommended' : ''" [tabindex]="index + 1"/>
              @if (mode === 'edition' && documentField.recommended && !getDoc(documentField.name)) {
                <app-required-field-text/>
              }
            </div>
          }
          @case ('date') {
            <div style="display: block">
              <p-date-picker [ngModel]="getDoc(documentField.name)" (ngModelChange)="setDoc(documentField.name, $event)" [name]="documentField.name"
                [showIcon]="false" dataType="string" [showButtonBar]="true" appendTo="body"
                dateFormat="yy-mm-dd" [view]="documentField.options?.includes('monthOnly') ? 'month': 'date'"
                [required]="respectRequired && documentField.required === true" [disabled]="mode !== DetailMode.EDITION" class="acted-highlight-req metadata-field"
                [ngClass]="(mode === 'edition' && documentField.recommended && !getDoc(documentField.name)) ? 'acted-highlight-recommended' : ''" [tabindex]="index + 1">
              </p-date-picker>
              @if (mode === 'edition' && documentField.recommended && !getDoc(documentField.name)) {
                <app-required-field-text/>
              }
            </div>
          }
          @case ('country') {
            <app-country-field [(country)]="document.country" [mode]="mode" [required]="respectRequired && documentField.required === true" [tabindex]="index + 1"></app-country-field>
          }
          @case ('place') {
            <app-place-field [country]="document.country" [(place)]="document.place" [mode]="mode" [required]="respectRequired && documentField.required === true" [tabindex]="index + 1">
            </app-place-field>
          }
          @case ('projects') {
            <app-projects-field [(projectCodes)]="document.project_codes" [mode]="mode" [required]="respectRequired && documentField.required === true"
              [recommended]="!!documentField.recommended" [tabindex]="index + 1">
            </app-projects-field>
          }
          @case ('activity') {
            <app-activity-field [(activity)]="document.activity" [mode]="mode" [required]="respectRequired && documentField.required === true" [tabindex]="index + 1">
            </app-activity-field>
          }
          @case ('voucherCode') {
            <app-voucher-code-field [(voucherCode)]="document.voucher_code" [balzacCode]="document.balzac_book?.saga_name" [date]="document.date" [mode]="mode"
              [required]="respectRequired && documentField.required === true" [tabindex]="index + 1">
            </app-voucher-code-field>
          }
          @case ('balzacBook') {
            <app-balzac-book-field [(balzacBook)]="document.balzac_book" [mode]="mode" [required]="respectRequired && documentField.required === true" [tabindex]="index + 1">
            </app-balzac-book-field>
          }
          @case ('supplier') {
            <app-supplier-field [(supplier)]="document.supplier" [mode]="mode" [required]="respectRequired && documentField.required === true" [tabindex]="index + 1">
            </app-supplier-field>
          }
          @case ('landlord') {
            <app-landlord-field [(landlord)]="document.landlord" [mode]="mode" [required]="respectRequired && documentField.required === true" [recommended]="!!documentField.recommended"  [tabindex]="index + 1">
            </app-landlord-field>
          }
          @case ('thirdPartyCode') {
            <app-third-party-code-field [(thirdPartyCode)]="document.third_party_code" [mode]="mode" [required]="respectRequired && documentField.required === true" [tabindex]="index + 1">
            </app-third-party-code-field>
          }
          @case ('budgetLines') {
            <app-budget-line-field [(budgetLines)]="document.budget_lines" [mode]="mode" [required]="respectRequired && documentField.required === true" [recommended]="!!documentField.recommended" [tabindex]="index + 1">
            </app-budget-line-field>
          }
          @case ('assetCategories') {
            <app-asset-categories-field [(assetCategories)]="document.asset_categories" [mode]="mode" [required]="respectRequired && documentField.required === true" [tabindex]="index + 1">
            </app-asset-categories-field>
          }
          @case ('programPlace') {
            <app-program-place-field [country]="document.country" [(programPlace)]="document.program_place" [mode]="mode" [required]="respectRequired && documentField.required === true"
              [recommended]="!!documentField.recommended" [tabindex]="index + 1">
            </app-program-place-field>
          }
          @case ('partner') {
            <app-partner-field [(partner)]="document.partner" [mode]="mode" [required]="respectRequired && documentField.required === true"
              [tabindex]="index + 1">
            </app-partner-field>
          }
        }
        <!-- end field switcher -->
      </div>
    }
  </div>
}
